import { getDynamicRelatedArticles } from '../services/interlinkingService';

// Deep linking strategy mapping - Manual overrides for specific "Golden Clusters"
export const DEEP_LINKING_MAP = {
  "best-iptv-service-2026": [
    { slug: "iptv-subscription-what-you-need-to-know", anchor: "iptv subscription plans" },
    { slug: "iptv-provider-comparison", anchor: "comparing top iptv services" },
    { slug: "iptv-free-trial-how-to-get-started", anchor: "test with free trial" },
    { slug: "best-iptv-providers-reddit-recommendations", anchor: "iptv provider reddit" },
    { slug: "iptv-vs-cable-which-is-better", anchor: "iptv vs traditional cable" }
  ],
  // ... (keep existing map entries if needed, or we can trust the dynamic engine)
};

/**
 * Smart Interlinking System
 * 
 * 1. Checks for Manual "Golden Cluster" in DEEP_LINKING_MAP
 * 2. If none, generates a "Spider Net" of links dynamically based on tags/category
 */
export const getRelatedArticles = (currentSlug, allArticles) => {
  // 1. Manual Override (Golden Clusters)
  if (DEEP_LINKING_MAP[currentSlug]) {
    return DEEP_LINKING_MAP[currentSlug]
      .map(rel => {
        const found = allArticles.find(a => a.slug === rel.slug);
        return found ? { ...found, anchor: rel.anchor } : null;
      })
      .filter(Boolean);
  }

  // 2. Dynamic Spider Net
  const currentArticle = allArticles.find(a => a.slug === currentSlug);
  if (!currentArticle) return [];

  return getDynamicRelatedArticles(currentArticle, allArticles);
};

export const generateDeepLink = (article, linkText = article.title) => {
  return {
    text: linkText,
    slug: article.slug,
    category: article.category
  };
};
